<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)" size="medium">
    <template #header>
      <h2 class="global-h2">Sorry, we couldn't find content for this Post.</h2>
    </template>
    <template #content>
      <p class="global-p" style="margin-top: 0">Atlas looks for content that fits the post theme and timing.<br />We couldn't find a strong enough match this time.</p>
    </template>
    <template #footer="{ closeModal }">
      <div style="display: flex; flex-direction: column; gap: 14px; width: 100%">
        <div style="display: flex; flex-wrap: wrap; gap: 12px">
          <SrpButton
            @click="
              emit('adjustTheme');
              closeModal();
            "
          >
            <template #icon><IconEmbedded name="ai_2" :size="20" /></template>
            Adjust the Post Theme
          </SrpButton>
          <SrpButton
            fill="outlined"
            color="gray"
            @click="
              emit('manualDraft');
              closeModal();
            "
          >
            <template #icon><IconEmbedded name="edit-pencil_2" :size="20" /></template>
            Manually Draft the Post
          </SrpButton>
        </div>
        <div>
          <LinkWithIcon tag="router-link" isDottedUnderline color="blue" :to="{ name: 'CalendarUploadContent', params: { customerId: props.customerId } }" @click="closeModal()">
            <template #icon><IconEmbedded name="upload_2" :size="18" /></template>
            <span>Or upload more photos</span>
          </LinkWithIcon>
        </div>
      </div>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";

const props = defineProps<{
  isVisible: boolean;
  customerId: string;
}>();

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
  (e: "adjustTheme"): void;
  (e: "manualDraft"): void;
}>();
</script>
